import React from 'react'

import { Box, Card, CardContent, CardHeader, Collapse } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

export const COLLAPSE_DURATION = 1500

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(6),
  },
  readonly: {
    opacity: 0.4,
  },
  headerRoot: {
    boxShadow: `0px 1px 0px ${theme.palette.grey[200]}`,
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
  },
}))

const CollapsingCard = ({ title, subheader, children, readonly, isExpanded, onExited }) => {
  const styles = useStyles()

  return (
    <Card
      className={styles.card}
      elevation={0}
    >
      <Box className={readonly ? styles.readonly : ''}>
        <CardHeader
          title={title}
          titleTypographyProps={{ variant: 'body1' }}
          subheader={subheader}
          subheaderTypographyProps={{ variant: 'subtitle2', color: 'textPrimary' }}
          classes={{
            root: styles.headerRoot,
            title: styles.title,
          }}
        />
        <Collapse
          in={isExpanded}
          timeout={COLLAPSE_DURATION}
          onExited={onExited}
        >
          <CardContent>{children}</CardContent>
        </Collapse>
      </Box>
    </Card>
  )
}

CollapsingCard.propTypes = {
  title: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  children: PropTypes.node,
  readonly: PropTypes.bool,
  isExpanded: PropTypes.bool,
  onExited: PropTypes.func,
}

export default CollapsingCard
